module.exports={resource:"player6",resourcePreview:"player6_preview",resourceCharred:"player6_charred",eyeless:!0};